// Ultimatum (Mars): the highest scoring constellation scores nothing; the
// rest score more. Ranked on the step-3 snapshot, the earlier word first
// among equals.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { ranked } from '../shared/standings';
import type { AlignmentDef } from '../types';

export const ultimatum: AlignmentDef = {
  id: 'ultimatum',
  planet: 'mars',
  name: 'Ultimatum',
  text: () => `Your highest scoring constellation scores 0. The rest score +${N.ultimatumPercent}%.`,
  standing: (entries) => {
    const [top, ...rest] = ranked(entries);
    if (!top) return [];
    return [{ index: top.index, zero: true }, ...rest.map((e) => ({ index: e.index, percent: N.ultimatumPercent }))];
  },
};
